var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "div",
        { staticStyle: { padding: "10px", background: "#fff" } },
        [
          _c("zk-button-group", {
            attrs: { groupName: "auth" },
            on: { Auth: _vm.showAuthDia, AddUser: _vm.showAddUserDia }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c("zk-table", {
        attrs: { height: 500, columns: _vm.columns, data: _vm.userList }
      }),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          attrs: {
            title: _vm.$t("role.addUser"),
            visible: _vm.userTransferDia,
            width: "55%",
            center: ""
          },
          on: {
            "update:visible": function($event) {
              _vm.userTransferDia = $event
            }
          }
        },
        [
          _c("zk-user-transfer", {
            ref: "userTransfer",
            attrs: { selectedData: _vm.selectedData }
          }),
          _vm._v(" "),
          _c(
            "span",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer"
            },
            [
              _c(
                "el-button",
                {
                  on: {
                    click: function($event) {
                      _vm.userTransferDia = false
                    }
                  }
                },
                [_vm._v(_vm._s(_vm.$t("common.cancel")))]
              ),
              _vm._v(" "),
              _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: { click: _vm.saveUserToRole }
                },
                [_vm._v(_vm._s(_vm.$t("common.confirm")))]
              )
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          attrs: { title: _vm.$t("role.authorization"), visible: _vm.authDia },
          on: {
            "update:visible": function($event) {
              _vm.authDia = $event
            }
          }
        },
        [
          _c("zk-auth-tree", {
            ref: "authTree",
            attrs: {
              selectRoleId: _vm.selectRoleId,
              authTree: _vm.authTree,
              checkedkeys: _vm.checkedkeys
            },
            on: {
              authSuces: function($event) {
                _vm.authDia = false
              }
            }
          }),
          _vm._v(" "),
          _c(
            "span",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer"
            },
            [
              _c(
                "el-button",
                {
                  on: {
                    click: function($event) {
                      _vm.authDia = false
                    }
                  }
                },
                [_vm._v(_vm._s(_vm.$t("common.cancel")))]
              ),
              _vm._v(" "),
              _c(
                "el-button",
                { attrs: { type: "primary" }, on: { click: _vm.auth } },
                [_vm._v(_vm._s(_vm.$t("common.confirm")))]
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-2ab98192", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2ab98192","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/cdpBase/baseComponents/roleUser/src/main.vue
// module id = null
// module chunks = 